import * as React from "react";

const enhanceWithClickOutside = require('react-click-outside');

const s = require("./sandwichMenu.scss");

interface ISandwichMenuProps {
    options: {
        label: string;
        onClick: () => any;
    }[];
    toTheLeft?: boolean;
};

interface ISandwichMenuState {
    isOpened: boolean;
};

class SandwichMenu extends React.Component<ISandwichMenuProps, ISandwichMenuState> {
    constructor(props: ISandwichMenuProps, context: any) {
        super(props, context);
        this.state = {
            isOpened: false,
        };
    }

    handleClickOutside() {
        this.setState({ isOpened: false });
    }

    onClickMenuIcon() {
        this.setState({ isOpened: !this.state.isOpened });
    }

    public render(): JSX.Element {
        const options = this.props.options.map(option => {
            return (
                <li key={option.label} onClick={(event) => option.onClick()}>{option.label}</li>
            );
        });

        return (
            <div>
                <a className={s.sandwich + (this.props.toTheLeft ? " " + s.toTheLeft : "")} onClick={(event) => this.onClickMenuIcon() }>
                    <i className="fa fa-bars" aria-hidden="true"></i>

                    {(this.state.isOpened ? (
                        <ul>
                            {options}
                        </ul>
                    ) : null)}
                </a>
            </div>

        );
    }
}

export default enhanceWithClickOutside(SandwichMenu);



// WEBPACK FOOTER //
// ./src/components/SandwichMenu/index.tsx